import { Navigate } from 'react-router-dom';
import {
  PageContainer,
  Skeleton,
  useRequireOrganization,
} from '@startupquickstart/frontend';

/**
 * Home page that redirects based on user type:
 * - Personal accounts (no organization) -> /home (mobile app page)
 * - Non-internal organizations -> /dashboard (hotel cards)
 * - Internal organizations -> /attractions (content portal)
 */
export function HomePage() {
  const { hasOrganization, isInternal, isLoading } = useRequireOrganization();

  // Show loading state while checking
  if (isLoading) {
    return (
      <PageContainer>
        <div className="space-y-4">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-64 w-full" />
        </div>
      </PageContainer>
    );
  }

  // Personal accounts -> mobile app page
  if (!hasOrganization) {
    return <Navigate to="/home" replace />;
  }

  // Non-internal organizations -> hotel dashboard
  if (!isInternal) {
    return <Navigate to="/dashboard" replace />;
  }

  // Internal organizations -> attractions (admin portal)
  return <Navigate to="/attractions" replace />;
}
